/*************************************************/
/* MENU                                          */
/*************************************************/

export function menu() {
    const selectors = {
        parentMenuItem: '.menu-nav__item--parent',
        menuItemParent: '.menu-nav__links--list-item',
        menuItemChildren: '.menu-nav__children',
        menuItemImage: '.menu-nav__image',
        menuItemChildImage: '.menu-nav__children--image',
        submenu: '.menu-nav--lvl-2',
        submenuLink: ".menu-nav__link",
        thirdLayerLink: ".menu-nav__link-third",
        header: '.header',
    };
    const classes = {
        active: "active",
        activeList: "active-list",
        headerSolid: 'header-solid',
    };
    const events = {
        enter: ['focusin', 'mouseenter'],
        exit: ['focusout', 'mouseleave']
    };

    let activeSecondLayerItem = null;
    let activeThirdLayerItem = null;

    const init = () => {
        document.querySelectorAll(selectors.parentMenuItem).forEach(setupFirstLayerEvents);
    };

    // Setup events for first layer items to show/hide submenu and initialize second layer
    const setupFirstLayerEvents = (menuItem) => {
        const submenu = menuItem.querySelector(selectors.submenu);

        events.enter.forEach(event => menuItem.addEventListener(event, () => toggleSubMenuVisibility(submenu, false)));
        events.exit.forEach(event => menuItem.addEventListener(event, (e) => {
            if (!menuItem.contains(e.relatedTarget)) {
                toggleSubMenuVisibility(submenu, true);
                resetActiveStates();
            }
        }));

        menuItem.querySelectorAll(selectors.menuItemParent).forEach(setupSecondLayerEvents);
    };

    // Setup events for second layer items and manage active state and hover for children
    const setupSecondLayerEvents = (secondLayerItem) => {
        const children = secondLayerItem.querySelector(selectors.menuItemChildren);
        const image = secondLayerItem.querySelector(selectors.menuItemImage);

        events.enter.forEach(event => secondLayerItem.addEventListener(event, () => {
            if (activeSecondLayerItem !== secondLayerItem) {
                resetSecondLayerState();
                activeSecondLayerItem = secondLayerItem;
                toggleActiveClassForChildren(secondLayerItem, children, image);
            }
        }));

        const thirdLayerItems = secondLayerItem.querySelectorAll(selectors.thirdLayerLink);
        setupThirdLayerHover(thirdLayerItems, secondLayerItem);
    };

    // Toggle submenu visibility and manage header class for visual effect
    const toggleSubMenuVisibility = (submenu, hidden) => {
        submenu?.setAttribute('aria-hidden', hidden);
        document.querySelector(selectors.header)?.classList.toggle(classes.headerSolid, !hidden);
        if (hidden) resetActiveStates();
    };

    // Reset both second and third layer active states
    const resetActiveStates = () => {
        resetSecondLayerState();
        resetThirdLayerState();
        activeSecondLayerItem = null;
        activeThirdLayerItem = null;
    };

    // Reset active state for second layer items
    const resetSecondLayerState = () => {
        if (activeSecondLayerItem) {
            activeSecondLayerItem.classList.remove(classes.active);
            activeSecondLayerItem.querySelector(selectors.menuItemChildren)?.classList.remove(classes.activeList);
            activeSecondLayerItem.querySelector(selectors.menuItemImage)?.classList.remove(classes.active);
        }
    };

    // Reset active state for third layer items and related images
    const resetThirdLayerState = () => {
        if (activeThirdLayerItem) {
            activeThirdLayerItem.classList.remove(classes.active);
            activeThirdLayerItem.parentNode.querySelector(selectors.menuItemChildImage)?.classList.remove(classes.active);
        }
    };

    // Activate the given second layer item and display its image if available
    const toggleActiveClassForChildren = (secondLayerItem, children, image) => {
        secondLayerItem.classList.add(classes.active);
        children?.classList.add(classes.activeList);
        image?.classList.add(classes.active);
    };

   // Setup hover events for third layer items, managing active state and image display
const setupThirdLayerHover = (thirdLayerItems, secondLayerItem) => {
    thirdLayerItems.forEach(item => {
        item.addEventListener("mouseover", () => handleThirdLayerHover(item, secondLayerItem));
        item.addEventListener("mouseleave", () => {
            if (activeThirdLayerItem === item) {
                resetThirdLayerState();
                
                // Reactivate the second-layer image if it exists
                const secondLayerImage = secondLayerItem.querySelector(selectors.menuItemImage);
                secondLayerImage?.classList.add(classes.active);
            }
        });
    });
};


    // Handle hover for third layer items to set the correct active state and image
    const handleThirdLayerHover = (item, secondLayerItem) => {
        if (activeThirdLayerItem && activeThirdLayerItem !== item) {
            resetThirdLayerState();
        }
        activeThirdLayerItem = item;
        item.classList.add(classes.active);

        const thirdLayerImage = item.parentNode.querySelector(selectors.menuItemChildImage);
        const secondLayerImage = secondLayerItem.querySelector(selectors.menuItemImage);

        if (thirdLayerImage) {
            secondLayerImage?.classList.remove(classes.active);
            document.querySelectorAll(selectors.menuItemChildImage).forEach(img => img.classList.remove(classes.active));
            thirdLayerImage.classList.add(classes.active);
        }
    };

    init();
}
